import { render, staticRenderFns } from "./MeetingArea.vue?vue&type=template&id=55b53d87&"
import script from "./MeetingArea.vue?vue&type=script&lang=ts&"
export * from "./MeetingArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports